<template>
  <div class="page_content module_page explore_entity_result program_result" v-if="permission && permission.version === '5'" aria-label="explore program guide results">

    <div class="row page-heading">
          <div class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11 input module_heading" role="heading" aria-level="1">
            <span class="module_icon ico-degreeProgram"></span>
            <div class="head_txt module_type_name ace_sec_hd" style="cursor: default;">Exploring {{total}} {{exploreProgramsLabelPlural}}</div>
            <template v-if="showAddCompletedCoursesOnResult && isStudentLogin && planningStream">
              <div class="float-right">
                <div class="float-left" style="border: 1px solid #157099; margin: 4px -2px; font-size: 18px;" v-if="showTransferredCoursesCreditProgress">
                  <span style="font-size: 15px; padding: 0 10px 0 10px; color: #8cbc3f;">saved {{countInfo.credit}} credits</span>
                </div>
                <b-button @click="addCompletedCourses" aria-label="add completed courses">Add Completed Courses</b-button>
              </div>
            </template>
          </div>

          <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1 btn_container">
            <!--
            <b-dropdown :animation="animation" variant="link" no-caret class="create-section-menu">
              <template slot="button-content">
                <span class="icon-menu3x3"></span>
              </template>
            </b-dropdown>
            <b-btn class="btn btn-primary">Request Info</b-btn>
            <b-btn class="btn btn-primary">Apply Now</b-btn>
            <div v-if="!isClearlyNextPackageEnabled" style="float: right;">
                <b-link v-if="isExplorePackageEnabled" class="btn" :to="{ name: 'exploreIntro' }" aria-label="Explore" tabindex="0">explore</b-link>
            </div>
            -->
            <div class="data_souce_info">
              <div id="dataSouceInfo">
                <span class="ic ic8-info5"></span>
              </div>
              <b-popover target="dataSouceInfo" container="dataSouceInfoPopup" triggers="hover" style="margin-top: 20px;">
                <div class="popup_content">
                  {{careerDataSource}}
                </div>
              </b-popover>
              <div id="dataSouceInfoPopup"></div>
            </div>
            <!-- ==== data_souce_info ==== -->
          </div>
      </div>

      <div class="page_subheading">
        <div class="row select_flds_container">

          <!-- Search Bar -->
          <div class="col-xl-7 col-lg-7 col-md-7 col-sm-12 col-xs-12 filter_fld_sec">
              <div class="row data-row" v-bind:class="{ 'fld_1': isAreaOfStudyEnabled, 'fld_2': isSubCategoryEnabled, 'fld_3': isProgramLevelEnabled, 'fld_4': isIncomeRangeEnabled, 'fld_5': isCollegeEnabled }">
                <div v-if="isAreaOfStudyEnabled" class="explore_filter">
                  <div class="popup_container">
                    <b-button id="areaOfStudyDropDown" @click.stop="openAreaOfStudyDropDown" class="form-field area-of-study ace_sec" tabindex="0">
                      <label for="state" :title="'Select ' + areaOfStudyLabel">
                        <span class="txt_sh">Select</span>
                        <span class="lbl_txt">{{areaOfStudyLabel}}</span>
                        <span class="icon-dropdown1"></span>
                      </label>
                    </b-button>
                  </div>
                  <div id="areaOfStudyDropDownPopup" class="dropdown_popover popup_container"></div>
                  <b-popover target="areaOfStudyDropDown" :show.sync='showAreaOfStudyDropDown' container="areaOfStudyDropDownPopup" triggers="blur">
                    <!--
                    <div class="header-content-row">
                      <span class="title">Select {{areaOfStudyLabel}}</span>
                      <button class="btn_close" aria-label="close" @click="closeAreaOfStudyDropDown">
                        <span class="ic-close"></span>
                      </button>
                    </div>
                    -->
                    <div class="popup_content">
                      <input type="text" id="areaOfStudySearchBox" class="input-search ml-1 mt-2 mb-2" :placeholder="'Type To Filter ' + areaOfStudyLabel" :aria-label="'Type To Filter ' + areaOfStudyLabel" style="width: 93%;" v-model.trim="programCategorySearch">
                      <template v-for="(areaOfStudy, index) in programGuideCategories">
                        <div class="field-row">
                          <input type="checkbox" :id="'areaOfStudy_' + index" :checked="areaOfStudy.isSelected" @input.stop="filterSelected(areaOfStudy, 'programGuideCategory')">
                          <label :for="'areaOfStudy_' + index">{{areaOfStudy.key}} <span v-if="showFacetCounts">[{{areaOfStudy.doc_count}}]</span></label>
                        </div>
                      </template>
                    </div>
                    <b-btn @click="closeAreaOfStudyDropDown" class="range-button">ok</b-btn>
                  </b-popover>
                </div>

                <div v-if="isSubCategoryEnabled" class="explore_filter">
                  <b-button @click.stop='openSubCategoryDropDown' id="subCategoryDropDown" role="button" class="form-field area-of-study ace_sec" tabindex="0">
                    <label for="state" :title="'Select ' + subCategoryLabel">
                      <span class="txt_sh">Select</span>
                      <span class="lbl_txt">{{subCategoryLabel}}</span>
                      <span class="icon-dropdown1"></span>
                    </label>
                  </b-button>
                  <div id="subCategoryDropDownPopup" class="dropdown_popover explore_filter_container"></div>
                  <b-popover v-if="isSubCategoryEnabled" target="subCategoryDropDown" :show.sync='showSubCategoryDropDown' container="subCategoryDropDownPopup" triggers="blur">
                    <!--
                    <div class="header-content-row">
                      <span class="title">Select {{subCategoryLabel}}</span>
                    </div>
                    -->
                    <div class="popup_content">
                      <input type="text" class="input-search ml-1 mt-2 mb-2" :placeholder="'Type To Filter ' + subCategoryLabel" style="width: 93%;" v-model.trim="programSubCategorySearch">
                      <template v-for="(subCategory, index) in programGuideSubCategories">
                        <div class="field-row">
                          <input type="checkbox" :id="'subCategory_' + index" :checked="subCategory.isSelected" @input.stop="filterSelected(subCategory, 'programGuideSubCategory')">
                          <label :for="'subCategory_' + index">{{subCategory.key}} <span v-if="showFacetCounts">[{{subCategory.count}}]</span></label>
                        </div>
                      </template>
                    </div>
                    <b-btn @click="closeSubCategoryDropDown" class="range-button">ok</b-btn>
                  </b-popover>
                </div>

                <div v-if="isCollegeEnabled" class="explore_filter">
                  <b-button @click.stop='openCollegeDropDown' id="collegeDropDown" role="button" class="form-field entity-type ace_sec" tabindex="0">
                    <label for="state" :title="'Select ' + collegeLabel">
                      <span class="txt_sh">Select</span>
                      <span class="lbl_txt">{{collegeLabel}}</span>
                      <span class="icon-dropdown1"></span>
                    </label>
                    <!--
                    <v-select class="select-field" v-model='minor' :options='minors' placeholder="Select or type in Minor(s)"></v-select>
                    -->
                  </b-button>
                  <div id="collegeDropDownPopup" class="dropdown_popover explore_filter_container"></div>
                  <b-popover v-if="isCollegeEnabled" target="collegeDropDown" :show.sync='showCollegeDropDown' container="collegeDropDownPopup" triggers="blur">
                    <!--
                    <div class="header-content-row program">
                      <span class="title">Select {{collegeLabel}}</span>
                      <button class="btn_close" aria-label="close" @click="closeprogramLevelDropDown">
                        <span class="ic-close"></span>
                      </button>
                    </div>
                    -->
                    <div class="popup_content">
                      <input type="text" class="input-search ml-1 mt-2 mb-2" :placeholder="'Type To Filter ' + collegeLabel" style="width: 93%;" v-model.trim="programCollegeSearch">
                      <template v-for="(college, index) in programGuideColleges">
                        <div class="field-row">
                          <input type="checkbox" :id="'college_' + index" :checked="college.isSelected" @input.stop="filterSelected(college, 'programGuideCollege')">
                          <label :for="'college_' + index">{{college.key}} <span v-if="showFacetCounts">[{{college.doc_count}}]</span></label>
                        </div>
                      </template>
                    </div>
                    <b-btn @click="closeCollegeDropDown" class="range-button">ok</b-btn>
                  </b-popover>
                </div>

                <div v-if="isProgramLevelEnabled" class="explore_filter">
                  <b-button @click.stop='openProgramLevelDropDown' id="programLevelDropDown" role="button" class="form-field entity-type ace_sec" tabindex="0">
                    <label for="state" :title="'Select ' + programLevelLabel">
                      <span class="txt_sh">Select</span>
                      <span class="lbl_txt">{{programLevelLabel}}</span>
                      <span class="icon-dropdown1"></span>
                    </label>
                    <!--
                    <v-select class="select-field" v-model='minor' :options='minors' placeholder="Select or type in Minor(s)"></v-select>
                    -->
                  </b-button>
                  <div id="programLevelDropDownPopup" class="dropdown_popover explore_filter_container"></div>
                  <b-popover v-if="isProgramLevelEnabled" target="programLevelDropDown" :show.sync='showprogramLevelDropDown' container="programLevelDropDownPopup" triggers="blur">
                    <!--
                    <div class="header-content-row program">
                      <span class="title">Select {{programLevelLabel}}</span>
                      <button class="btn_close" aria-label="close" @click="closeprogramLevelDropDown">
                        <span class="ic-close"></span>
                      </button>
                    </div>
                    -->
                    <div class="popup_content">
                      <input type="text" class="input-search ml-1 mt-2 mb-2" :placeholder="'Type To Filter ' + programLevelLabel" style="width: 93%;" v-model.trim="programLevelSearch">
                      <template v-for="(level, index) in programGuideLevels" >
                        <div class="field-row">
                          <input type="checkbox" :id="'levelKey_' + index" :checked="level.isSelected" @input.stop="filterSelected(level, 'programGuideLevel')">
                          <label :for="'levelKey_' + index">{{level.key}} <span v-if="showFacetCounts">[{{level.doc_count}}]</span></label>
                        </div>
                      </template>
                    </div>
                    <b-btn @click="closeprogramLevelDropDown" class="range-button">ok</b-btn>
                  </b-popover>
                </div>
<!--
                <div v-if="isIncomeRangeEnabled" id="incomeRangeDropDownPopup" class="dropdown_popover explore_filter_container popup_income_range"></div>
                <div v-if="isIncomeRangeEnabled" @click.stop='openIncomeRangeDropDown' id="incomeRangeDropDown" class="form-field income-range ace_sec" tabindex="0">
                  <label for="state" :title="'Select ' + incomeRangeLabel">
                    <span class="txt_sh">Select</span>
                    <span class="lbl_txt">{{incomeRangeLabel}}</span>
                    <span class="icon-dropdown1"></span>
                  </label>
                </div>

                <b-popover v-if="isIncomeRangeEnabled" target="incomeRangeDropDown" :show.sync='showIncomeRangeDropDown' container="incomeRangeDropDownPopup" triggers="blur">

                    <div class="row">
                      <div class="col-12">
                        <template v-for="range in formattedFacetResults.programGuideIncomeRange" >
                          <div class="field-row">
                            <input type="radio" :checked="range.isSelected" @input.stop="filterSelected(range, 'programGuideIncomeRange')">
                            {{range.label}} <span v-if="showFacetCounts">[{{range.doc_count}}]</span></input>
                          </div>
                        </template>

                        <div class="sec_sep"></div>

                        <b-input-group class="input_grp">
                          <div class="range-group">
                            <span class="input-title">min</span>
                            <b-form-input id="customIncomeMin" v-model="customIncomeMin" number="true" type="number" min="0"></b-form-input>
                          </div>

                          <div class="range-group">
                              <span class="input-title">max</span>
                            <b-form-input id="customIncomeMax" v-model="customIncomeMax" number="true" type="number" min="0"></b-form-input>
                          </div>
                        </b-input-group>
                      <b-btn @click="customRangeSelected" class="range-button">ok</b-btn>
                    </div>
                  </div>
                </b-popover>
-->
                <div class="explore_filter">
                  <div class="btn_container">
                    <b-button v-if="isIncomeRangeEnabled || isModalityEnabled || isCustomTagFilterEnabled || isFundingFilterEnabled" id="filterDropDown" @click.stop="openFilterDropDown" class="ace_sec_txt" tabindex="0">
                      <span class="icon-filter"></span>
                    </b-button>
                  </div>
                  <div id="programListFilterPopup" class="dropdown_popover explore_filter_container"></div>
                  <b-popover target="sortByDropDown" :show.sync='showFilterDropDown' container="programListFilterPopup" triggers="blur">
                    <template >
                      <div class="header-content-row">
                        <span class="title">Filter</span>
                      </div>
                      <div class="popup_content">
                        <template v-for="(customTag, index) in customTagOptions" v-if="isCustomTagFilterEnabled">
                          <div class="field-row ace_sec" :class="'customTagClass_' + index">
                            <input type="checkbox"
                              :id="'customTag_' + index"
                              :checked="isCustomTagChecked(customTag)"
                              @input.stop="filterSelected(customTag, 'programGuideCustomTag')"
                              :ref="'customInput_' + index">
                            <label :for="'customTag_' + index">{{customTag.label}}</label>
                          </div>
                        </template>

                        <div class="field-row filter_fld_label" v-if="isModalityEnabled">
                          {{modalityLabel}}
                        </div>
                        <div class="filter_fld_container">
                          <template v-for="(mType, index) in programGuideMadalityTypeArray" v-if="isModalityEnabled">
                            <div class="field-row filter_fld_val">
                              <input type="checkbox"
                              :id="'mType_' + index"
                              :checked="isModalityChecked(mType)"
                              ref="checkBoxInput"
                              class="ace_sec"
                              @input.stop="filterModalitySelected(mType, 'programGuideModalityType')">
                              <label :for="'mType_' + index">{{mType.value}} </label>
                            </div>
                          </template>
                        </div>

                        <div class="field-row filter_fld_label" v-if="isCostRangeEnabled">
                          {{costRangeLabel}}
                        </div>
                        <div class="filter_fld_container">
                          <template v-for="(range, index) in formattedFacetResults.programGuideCostRange" v-if="isCostRangeEnabled">
                            <div class="field-row filter_fld_val">
                              <input type="radio" :id="'costRange_' + index" :checked="range.isSelected" @input.stop="filterSelected(range, 'programGuideCostRange')" class="ace_sec">
                              <label :for="'costRange_' + index">{{range.label}}</label>
                            </div>
                          </template>
                        </div>

                        <div class="field-row filter_fld_label" v-if="isFundingFilterEnabled">
                          {{fundingLabel}}
                        </div>
                        <div class="filter_fld_container">
                          <template v-for="(fType, index) in programGuideFundingTypeArray" v-if="isFundingFilterEnabled">
                            <div class="field-row filter_fld_val">
                              <input type="checkbox"
                                :id="'fType_' + index"
                                :checked="isFundingChecked(fType)"
                                :ref="'customInput_' + index"
                                class="ace_sec"
                                @input.stop="filterFundingSelected(fType, 'programGuideFundingType')">
                              <label :for="'fType_' + index">{{fType.value}}</label>
                            </div>
                          </template>
                        </div>

                        <div class="field-row filter_fld_label" v-if="isIncomeRangeEnabled">
                          {{incomeRangeLabel}}
                        </div>
                        <div class="filter_fld_container">
                          <template v-for="(range, index) in formattedFacetResults.programGuideIncomeRange" v-if="isIncomeRangeEnabled">
                            <div class="field-row filter_fld_val">
                              <input type="radio"
                                :id="'incomeRange_' + index"
                                :checked="range.isSelected"
                                :ref="'customInput_' + index"
                                class="ace_sec"
                                @input.stop="filterSelected(range, 'programGuideIncomeRange')">
                              <label :for="'incomeRange_' + index">{{range.label}} <span v-if="showFacetCounts">[{{range.doc_count}}]</span></label>
                            </div>
                          </template>

                          <b-input-group class="input_grp" v-if="isIncomeRangeEnabled">
                            <div class="range-group filter_fld_val">
                              <span class="input-title">min</span>
                              <b-form-input id="customIncomeMin" v-model="customIncomeMin" number="true" type="number" min="0"></b-form-input>
                            </div>

                            <div class="range-group filter_fld_val">
                                <span class="input-title">max</span>
                              <b-form-input id="customIncomeMax" v-model="customIncomeMax" number="true" type="number" min="0"></b-form-input>
                            </div>
                          </b-input-group>
                        </div>


                      </div>
                    </template>
                    <div class="btn_container">
                      <b-btn @click="closeFilterDropDown" class="range-button">ok</b-btn>
                    </div>
                  </b-popover>
                </div>

          </div>
        </div>

          <!-- Page Buttons -->
          <div class="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-xs-12 search_bx_sec">

          <div class="search-box-container">
            <input v-if="isSearchBarEnabled" type="text" class="input-search" :placeholder="'search for ' + exploreProgramsLabelPlural" v-on:keypress.enter="searchButtonClicked" v-model.trim="searchTerms" :aria-label="'search for ' +  exploreProgramsLabelPlural">
            <button v-if="isSearchBarEnabled" class="btn btn_srh" @click="searchButtonClicked" aria-label="go">
              <span v-if="isSearchBarEnabled" class="ic_srh ic_search"></span>
              <!--
              <span class="txt_srh">search</span>
              -->
            </button>
            <!--<span class="icon-filter" v-b-modal.filtering></span>-->
            <div id="programListSortPopup" class="sort_by_popover"></div>
            <b-button v-if="isSortByEnabled" id="sortByDropDown" @click.stop="openSortByDropDown" class="srt_btn_explore sort-by ace_sec_txt" tabindex="0">
              <span class="ic2_sort2 sort-by-icon"></span>
              <span class="txt_srt">sort</span>
            </b-button>
          </div>
          <b-popover
            target="sortByDropDown"
            :show.sync='showSortByDropDown'
            custom-class="sort_by_modal"
            container="programListSortPopup"
            triggers="blur">
              <div class="header-content-row">
                <span class="title">Sort by</span>
              </div>
              <div class="popup_content">
                <template v-for="sort in sortByOptions">
                  <div class="field-row">
                    <div class="form-check">
                      <input type="radio" class="form-check-input" :id="sort.name" :checked="selectedSort" v-model="selectedSort" v-bind:value="sort.clause">
                      <label class="form-check-label" :for="sort.name">{{ sort.name }}</label>
                    </div>
                  </div>
                </template>
              </div>
              <div class="btn_container pagination_sty3">
                <b-btn @click="closeSortByDropDown" class="btn">
                  ok
                </b-btn>
              </div>

          </b-popover>


          <!--
          <button type="button" :disabled="this.firstPage" @click="prev" class="btn btn_trans" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
          <span class="page_count" aria-hidden="true">{{ page + 1  }}</span>
          <select v-model="pageSize" @change="resetPage" aria-label="page size" class="page_size">
            <option v-for="option in sizeOptions" v-bind:value="option">
                {{ option }}
            </option>
          </select>

          <button type="button" :disabled="this.lastPage" @click="next" class="btn btn_trans" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>-->

        </div>

        <div class="list-view-section">
          <b-input-group>
            <template v-for="areaOfStudy in formattedFacetResults.programGuideCategory">
              <div v-if="areaOfStudy.isSelected" class="search_tag">
                <span class="title category" :aria-label="areaOfStudy.key">{{areaOfStudy.key}}</span>
                <button class="ic_btn ic_bin" aria-label="delete" tabindex="0" @click.stop="filterSelected(areaOfStudy, 'programGuideCategory', true)">
                </button>
              </div>
            </template>
            <template v-for="subCategory in formattedFacetResults.programGuideSubCategory">
              <div v-if="subCategory.isSelected" class="search_tag">
                <span class="title category" :aria-label="subCategory.key">{{subCategory.key}}</span>
                <button class="ic_btn ic_bin" aria-label="delete" tabindex="0" @click.stop="filterSelected(subCategory, 'programGuideSubCategory', true)">
                </button>
              </div>
            </template>
            <template v-for="college in formattedFacetResults.programGuideCollege">
              <div v-if="college.isSelected" class="search_tag">
                <span class="title type" :aria-label="college.key">{{college.key}}</span>
                <button class="ic_btn ic_bin" aria-label="delete" tabindex="0" @click.stop="filterSelected(college, 'programGuideCollege', true)">
                </button>
              </div>
            </template>
            <template v-for="level in formattedFacetResults.programGuideLevel">
              <div v-if="level.isSelected" class="search_tag">
                <span class="title type" :aria-label="level.key">{{level.key}}</span>
                <button class="ic_btn ic_bin" aria-label="delete" tabindex="0" @click.stop="filterSelected(level, 'programGuideLevel', true)">
                </button>
              </div>
            </template>
            <template v-for="range in formattedFacetResults.programGuideIncomeRange">
              <div v-if="range.isSelected" class="search_tag">
                <span class="title income_range" :aria-label="range.label">income {{range.label}}</span>
                <button  class="ic_btn ic_bin" aria-label="delete" tabindex="0" @click.stop="clearRangeFilter">
                </button>
              </div>
            </template>
            <template v-for="range in formattedFacetResults.programGuideCostRange">
              <div v-if="range.isSelected" class="search_tag">
                <span class="title income_range" :aria-label="range.label">cost {{range.label}}</span>
                <button  class="ic_btn ic_bin" aria-label="delete" tabindex="0" @click.stop="clearCostRangeFilter">
                </button>
              </div>
            </template>

            <template v-if="modalityType.length > 0">
              <div class="search_tag" v-for="m in modalityType">
                <span class="title income_range" :aria-label="m.value">{{m.value}}</span>
                <button  class="ic_btn ic_bin" aria-label="delete" tabindex="0" @click.stop="filterModalitySelected(m, 'programGuideModalityType', true)">
                </button>
              </div>
            </template>
            <template v-if="fundingType.length > 0">
              <div class="search_tag" v-for="f in fundingType">
                <span class="title income_range" :aria-label="f.value">{{f.value}}</span>
                <button  class="ic_btn ic_bin" aria-label="delete" tabindex="0" @click.stop="filterFundingSelected(f, 'programGuideFundingType', true)">
                </button>
              </div>
            </template>

            <template v-for="customTag in programGuideCustomTags">
              <div v-if="customTag.isSelected" class="search_tag">
                <span class="title type" :aria-label="customTag.key">{{customTag.key}} Pathways</span>
                <button class="ic_btn ic_bin" aria-label="delete" tabindex="0" @click.stop="filterSelected(customTag, 'programGuideCustomTag', true)">
                </button>
              </div>
            </template>
            <div v-if="programGuideSearchCustomIncomeMax && programGuideSearchCustomIncomeMin" class="search_tag">
              <span class="title income_range">${{programGuideSearchCustomIncomeMin}} - ${{programGuideSearchCustomIncomeMax}}</span>
              <button class="ic_btn ic_bin" aria-label="delete" tabindex="0" @click.stop="clearRangeFilter">
              </button>
            </div>
            <div v-if="programGuideSearchCustomIncomeMax && !programGuideSearchCustomIncomeMin" class="search_tag">
              <span class="title income_range"> < ${{programGuideSearchCustomIncomeMax}}</span>
              <button class="ic_btn ic_bin" aria-label="delete" tabindex="0" @click.stop="clearRangeFilter">
              </button>
            </div>
            <div v-if="!programGuideSearchCustomIncomeMax && programGuideSearchCustomIncomeMin" class="search_tag">
              <span class="title income_range"> > ${{programGuideSearchCustomIncomeMin}}</span>
              <button class="ic_btn ic_bin" aria-label="delete" tabindex="0" @click.stop="clearRangeFilter">
              </button>
            </div>
          </b-input-group>
        </div>

      </div>

    </div> <!-- .page_subheading -->

    <div class="page_content_container" style="overflow-y: hidden !important;" id="program-results-list">

      <template v-if="formattedResults.length > 0">
        <virtual-list
          class="item-list"
          :data-key="'uuid'"
          :data-sources="formattedResults"
          :data-component="itemComponent"
          :estimate-size="60"
          :extra-props="{parent: parentComponent}"
          :item-style="{'border-bottom': '1px solid #e6e6e6'}"
        />
      </template>

      <div class="list_container">

        <template v-if="isResultsLoaded && formattedResults.length == 0">
          <div class="data_tbl_container">
            <div class="no_result">No result found</div>
          </div>
        </template>

        <template v-if="showCreditProgressPopup">
          <explore-program-credit-progress
              :title="selectedProgramGuide.title"
              :stream-id="planningStream.uuid"
              :program-id="selectedProgramGuide.uuid"
              :credit-progress-target-id="creditProgressTargetId">
          </explore-program-credit-progress>
        </template>

      </div> <!-- .list_container -->
      </div> <!-- .page_content_container -->


      <div class="image_filters_container">
        <!-- ======================= -->
        <!-- ==== Image Filters ==== -->
        <!-- ======================= -->

        <!-- ==== Purple ==== -->
        <svg>
          <filter id="fltPurple">
            <feColorMatrix
            type="matrix"
            values="1 -0.2 0 0 0
                    0 1 0 -0.1 0
                    0 1.2 1 0.1 0
                    0 0 1.7 1 0 "/>
          </filter>
        </svg>
        <!-- ==== Purple ==== -->

        <!-- ==== Yellow ==== -->
        <svg>
          <filter id="fltYellow">
            <feColorMatrix
            type="matrix"
            values="1 0 0 0 0
                    -0.2 1.0 0.3 0.1 0
                    -0.1 0 1 0 0
                      0 0 0 1 0 "/>
          </filter>
        </svg>
        <!-- ==== Yellow ==== -->

        <!-- ==== Cyan ==== -->
        <svg>
          <filter id="fltCyan">
            <feColorMatrix
              type="matrix"
              values="1 0 0 1.9 -2.2
                      0 1 0 0.0 0.3
                      0 0 1 0 0.5
                      0 0 0 1 0.2 "/>
          </filter>
        </svg>
        <!-- ==== Cyan ==== -->

        <!-- ==== Black & White ==== -->
        <svg>
          <filter id="fltBlackAndWhite">
            <feColorMatrix
              type="matrix"
              values="0 1 0 0 0
                      0 1 0 0 0
                      0 1 0 0 0
                      0 1 0 1 0 "/>
          </filter>
        </svg>
        <!-- ==== Black & White ==== -->

        <!-- ==== Old Times ==== -->
        <svg>
          <filter id="fltOldTimes">
            <feColorMatrix
              type="matrix"
              values="1 0 0 0 0
                      -0.4 1.3 -0.4 0.2 -0.1
                      0 0 1 0 0
                      0 0 0 1 0 "/>
          </filter>
        </svg>
        <!-- ==== Old Times ==== -->

        <!-- ==== Cold Life ==== -->
        <svg>
          <filter id="fltColdLife">
            <feColorMatrix
              type="matrix"
              values="1 0 0 0 0
                      0 1 0 0 0
                      -0.2 0.2 0.1 0.4 0
                      0 0 0 1 0 "/>
          </filter>
        </svg>
        <!-- ==== Cold Life ==== -->

        <!-- ==== Sepium ==== -->
        <svg>
          <filter id="fltSepium">
            <feColorMatrix
              type="matrix"
              values="1.3 -0.3 1.1 0 0
                      0 1.3 0.2 0 0
                      0 0 0.8 0.2 0
                      0 0 0 1 0 "/>
          </filter>
        </svg>
        <!-- ==== Sepium ==== -->

        <!-- ==== Milk ==== -->
        <svg>
          <filter id="fltMilk">
            <feColorMatrix
              type="matrix"
              values="0 1.0 0 0 0
                      0 1.0 0 0 0
                      0 0.6 1 0 0
                      0 0 0 1 0 "/>
          </filter>
        </svg>
        <!-- ==== Milk ==== -->

        <!-- ======================= -->
        <!-- ==== Image Filters Ends ==== -->
        <!-- ======================= -->
      </div> <!-- .image_filters_container -->


  </div>
</template>

<script>
import '../../../assets/module/sass/explore/explore.scss'
import '../../../assets/module/css/user/userList.min.css'
import '../../../assets/module/css/institution/institutionEntities.min.css'
import ExploreProgramCreditProgress from './ExploreProgramCreditProgress'
import { mapActions, mapState } from 'vuex'
import { PACKAGE } from '../../../package_constants'
import { PackageUtil } from '../../../package_utils'
import _ from 'lodash'
import VClamp from 'vue-clamp'
import ProgramGuideItem from './ProgramGuideItem'
import VirtualList from 'vue-virtual-scroll-list'

export default {
  name: 'explore-program-guide-results',
  components: {
    ExploreProgramCreditProgress,
    VClamp,
    VirtualList
  },
  data () {
    return {
      itemComponent: ProgramGuideItem,
      programCategorySearch: '',
      programSubCategorySearch: '',
      programCollegeSearch: '',
      programLevelSearch: '',
      size: 500, // NOTE: ElasticSearch needs size parameter set or defaults to 10
      isResultsLoaded: false,
      indexesSelected: [],
      purchasedPrograms : [],
      allIndexes: ['programguide'],
      folders: [],
      allFolders: [],
      privateLibraryList: [],
      publicLibraryList: [],
      userId: localStorage.getItem('userid'),
      permission: {},
      libraryList: '',
      searchTerms: '',
      modalityType: [],
      fundingType: [],
      source: [
        'uuid',
        'institutionId',
        'title',
        'description',
        'creationTime',
        'lastUpdatedTime',
        'type',
        'programLevel',
        'medianIncomePerYear',
        'growthRate',
        'growthRateDoubleFormat',
        'totalJobPostings',
        'cipCode',
        'code',
        'thumbnailURL',
        'userExternalId',
        'customTags',
        'lowestPrice',
        'lowestPriceCurrency',
        'cost',
        'modalityType',
        'fundingType',
        'pragyaProgram',
        'freeProgram',
        'paymentProcessedOutOfPragya',
        'disableLMI',
        '_score'
      ],
      sorts: [
        {name: 'Relevance', clause: [{_score: {order: 'desc'}}]},
        {name: 'Title', clause: [{'title.raw': {order: 'asc'}}]},
        {name: 'Median Income', clause: [{medianIncomePerYear: {order: 'desc'}}]},
        {name: 'Job Postings', clause: [{totalJobPostings: {order: 'desc'}}]},
        {name: 'Growth Rate', clause: [{growthRateDoubleFormat: {order: 'desc'}}]}
      ],
      selectedSort: {},
      validLearningSpaceCategories: {
        LearningSpace: 'LearningSpace',
        Institution: 'Institution',
        Institute_Public: 'Institute_Public',
        User_Private: 'User_Private'
      },
      privateLearningSpaceCategories: {Institute_Public: 'Institute_Public', User_Private: 'User_Private'},
      selectedFacetNames: [],
      facetFieldMap: {
        programGuideCategory: 'category.raw',
        programGuideSubCategory: 'subCategory.raw',
        programGuideCollege: 'colleges.raw',
        programGuideLevel: 'programLevel.keyword',
        programGuideCustomTag: 'customTags.keyword',
        programGuideIncomeRange: 'medianIncomePerYear',
        programGuideCostRange : 'cost',
        programGuideModalityType : 'modalityType',
        programGuideFundingType : 'fundingType'
      },
      filter: {},
      showAreaOfStudyDropDown: false,
      showSubCategoryDropDown: false,
      showCollegeDropDown: false,
      showprogramLevelDropDown: false,
      showIncomeRangeDropDown: false,
      isIncomeRangeDirty: false,
      showSortByDropDown: false,
      showFilterDropDown: false,
      customIncomeMin: '',
      customIncomeMax: '',
      navigationErrorMessage: 'No CIP data found for this Program Guide. Please re-upload to see more details',
      selectedProgramGuide: null,
      creditProgressTargetId: '',
      showCreditProgressPopup: false,
      titlePopoverEnabled: false,
      allProgramProgress: {},
      countInfo: null
    }
  },

  async created () {
    this.showLoader()
    this.countInfo = await this.loadSelfReportedProgramCountInfo()
    this.allProgramProgress = await this.loadAllProgramCreditProgress()
  },

  async mounted () {
    this.showLoader()
    this.purchasedPrograms = await this.loadAllPurchasePrograms()
    this.initializeSearchData()
    let allFolders = []
    let publicLibraryList = []
    let privateLibraryList = []
    let validCategories = this.validLearningSpaceCategories
    let privateCategories = this.privateLearningSpaceCategories

    let permission = await this.loadPermission()
    let learningSpaces = await this.loadLibrariesForUser(this.userId)
    let institution = await this.loadInstitutionDetail()
    let associatedInstitutions = await this.loadAssociatedInstitutionDetail()
    learningSpaces.push(institution)
    for (var i = 0; i < learningSpaces.length; i++) {
      const learningSpace = learningSpaces[i]
      const category = learningSpace.category
      if (!validCategories[category]) {
        continue
      }
      let libraryList = privateCategories[category] ? privateLibraryList : publicLibraryList
      libraryList.push(learningSpace.uuid)
      allFolders.push(learningSpace.uuid)
    }
    this.permission = permission
    this.allFolders = allFolders
    this.publicLibraryList = publicLibraryList
    // Add The Associsted Institution Ids Here
    if(this.showAffiliatedProgramsOnResult()){
      this.publicLibraryList  = this.publicLibraryList.concat(institution.associatedInstitutions)
    }
    this.privateLibraryList = privateLibraryList
    await this.loadAllBookmarks()
    setTimeout(() => {
      this.loadProgramGuideResults()
    }, 0)
    window.addEventListener('resize', this.handleWindowResize)
  },

  methods: {
    ...mapActions([
      'loadPermission',
      'searchForProgramGuides',
      'loadLibrariesForUser',
      'loadInstitutionDetail',
      'loadAllBookmarks',
      'loadCreateBookmarks',
      'loadDeleteBookmark',
      'saveProgramGuideSearchState',
      'loadPlanningStream',
      'loadLogDashboardActivity',
      'loadProgramScrollTop',
      'loadProgramScrollLeft',
      'loadAllProgramCreditProgress',
      'loadSelfReportedProgramCountInfo',
      'loadAssociatedInstitutionDetail',
      'loadAllPurchasePrograms'
    ]),

    showLoader () {
      this.$parent.$refs.loadingModal.show()
    },

    hideLoader () {
      this.$parent.$refs.loadingModal.hide()
    },

    isCustomTagChecked (customTag) {
      let data = _.find(this.programGuideCustomTags, (item) => {
        return (item.isSelected && (item.key.toLowerCase() === customTag.key.toLowerCase()))
      })
      return (data !== undefined)
    },
    isModalityChecked (modality){
      if (this.modalityType.indexOf(modality) !== -1) {
        return true
      }
      return false
    },
    isFundingChecked (funding){
      if (this.fundingType.indexOf(funding) !== -1) {
        return true
      }
      return false
    },
    filterModalitySelected (facet, fieldName, isdelete){
      let index = this.modalityType.indexOf(facet)
      if (!isdelete && index === -1) {
        this.modalityType.push(facet)
      } else if (index > -1){
        this.modalityType.splice(index, 1)
      }
      this.filterSelected(facet, fieldName, isdelete)
    },
    filterFundingSelected (facet, fieldName, isdelete){
      let index = this.fundingType.indexOf(facet)
      if (!isdelete && index === -1) {
        this.fundingType.push(facet)
      } else if (index > -1){
        this.fundingType.splice(index, 1)
      }
      this.filterSelected(facet, fieldName, isdelete)
    },
    setPrecision (n) {
      if (Number(n) === n && n % 1 !== 0) {
        return 1
      }
      return 0
    },

    joinListWithCommas (stringList) {
      let str = []
      for (var i = 0; i < stringList.length; i++) {
        if (str.length === 0) {
          str = stringList[i]
        } else {
          str = str + ',' + stringList[i]
        }
      }
      return str
    },

    searchButtonClicked () {
      let searchTerms = this.searchTerms
      if (searchTerms && searchTerms.length > 0) {
        this.selectedSort = this.relevanceSort
      } else {
        this.selectedSort = this.titleSort
      }
      return this.loadProgramGuideResults()
    },

    loadProgramGuideResults () {
      this.saveProgramGuideSearchState({
        terms: this.searchTerms,
        sort: { clause: this.selectedSort },
        filter: this.filter,
        selectedFacetNames: this.selectedFacetNames,
        customIncomeMin: this.customIncomeMin,
        customIncomeMax: this.customIncomeMax
      })
      this.isResultsLoaded = false
      let loadSearchResults = this.searchForProgramGuides
      let filter = this.buildFilter()
      let facets = this.buildFacets()
      let isFacetResultsEmpty = this.isFacetResultsEmpty
      const searchInput = {
        terms: this.searchTerms,
        sort: this.selectedSort,
        source: this.source,
        from: 0,
        size: this.size,
        indexList: this.formattedIndexList,
        libraryList: this.formattedLibraryList,
        privateLibraryList: this.privateLibraryList,
        publicLibraryList: this.publicLibraryList,
        userId: this.userId,
        facets: facets,
        filter: filter,
        facetNames: this.allFacetNames,
        selectedFacetNames: this.selectedFacetNames // NOTE: uncomment for dynamic faceting
        // selectedFacetNames: isFacetResultsEmpty ? this.selectedFacetNames : this.allFacetNames // NOTE: uncomment for "sticky" faceting
      }
      if (this.isStickyFacetsEnabled) {
        searchInput.selectedFacetNames = isFacetResultsEmpty ? this.selectedFacetNames : this.allFacetNames
      }
      loadSearchResults(searchInput).then(res => {
        setTimeout(() => {
          this.isResultsLoaded = true
          this.setListHeight()
          this.hideLoader()
          $('.item-list').animate({
            scrollTop: this.programScrollTop
          }, 0)
          // this.loadPlanningStream()
        }, 0)
      })
    },

    checkTitleLength (rowNo) {
      let titleContainerHeight = $('#entityName_' + rowNo).innerHeight()
      if (titleContainerHeight > 59) {
        this.titlePopoverEnabled = true
      } else {
        this.titlePopoverEnabled = false
      }
    },
    alreadyPurchased (programGuide){
        for (var i in this.purchasedPrograms) {
          if(this.purchasedPrograms[i]==="ALL" || this.purchasedPrograms[i]===programGuide.uuid){
            return true
          }
        }
        return false
    },
    goToProgramGuideDetail (programGuide, rowNo) {
      this.loadProgramScrollLeft($('.item-list').scrollLeft())
      // this.loadProgramScrollTop($('.item-list').scrollTop())
      $('.item-list').scrollTop(223 * rowNo)
      $('.item-list div:first-child').height((223 * rowNo) + 2000)
      this.$store.commit('LOAD_PROGRAM_GUIDE', {})
      if (!programGuide.cipCode || !programGuide.code) {
        return this.notifyFailure(this.navigationErrorMessage)
      }
      console.log('#entityRow_' + rowNo + ' --> ' + 223 * rowNo)
      /* $('.item-list').animate({
        scrollTop: $('#entityRow_' + rowNo).offset().top
      }, 2000) */
      let routerParams = {
        cipCode: programGuide.cipCode,
        programGuideCode: programGuide.code,
        type: programGuide.type,
        pgInstitutionId : programGuide.institutionId,
        returnTo: 'exploreProgramGuideResults',
        showBackToResultButton: true
      }
      this.loadLogDashboardActivity({action: 'clickExploreProgramResult', page: 'explorePrograms', link: '', programCipCode: programGuide.cipCode})
      return this.$router.push({ name: 'programGuideIntroduction', params: routerParams, query: {returnTo: 'exploreProgramGuideResults'} })
    },

    getProgramGuideBookmark (programGuide) {
      let bookmarks = this.bookmarks
      if (!bookmarks || !bookmarks.length) {
        return false
      }
      let target = false
      bookmarks.forEach(bookmark => {
        if (bookmark.entityUuid === programGuide.uuid) {
          target = bookmark
        }
      })
      return target
    },

    openAreaOfStudyDropDown () {
      this.loadLogDashboardActivity({action: 'clickExploreProgramAreaOfStudy', page: 'explorePrograms', link: ''})
      $('#areaOfStudyDropDownPopup .popup').attr('tabindex', '0')
      this.showAreaOfStudyDropDown = !this.showAreaOfStudyDropDown
    },

    closeAreaOfStudyDropDown () {
      this.showAreaOfStudyDropDown = false
    },

    openSubCategoryDropDown () {
      this.loadLogDashboardActivity({action: 'clickExploreProgramSubCategory', page: 'explorePrograms', link: ''})
      this.showSubCategoryDropDown = !this.showSubCategoryDropDown
    },

    closeSubCategoryDropDown () {
      this.showSubCategoryDropDown = false
    },

    openCollegeDropDown () {
      this.loadLogDashboardActivity({action: 'clickExploreProgramCollege', page: 'explorePrograms', link: ''})
      this.showCollegeDropDown = !this.showCollegeDropDown
    },

    closeCollegeDropDown () {
      this.showCollegeDropDown = false
    },

    openProgramLevelDropDown () {
      this.loadLogDashboardActivity({action: 'clickExploreProgramProgramLevel', page: 'explorePrograms', link: ''})
      this.showprogramLevelDropDown = !this.showprogramLevelDropDown
    },

    closeprogramLevelDropDown () {
      this.showprogramLevelDropDown = false
    },

    openIncomeRangeDropDown () {
      this.loadLogDashboardActivity({action: 'clickExploreProgramIncome', page: 'explorePrograms', link: ''})
      this.showIncomeRangeDropDown = !this.showIncomeRangeDropDown
    },

    closeIncomeRangeDropDown () {
      this.showIncomeRangeDropDown = false
    },

    openSortByDropDown () {
      this.loadLogDashboardActivity({action: 'clickExploreProgramSortBy', page: 'explorePrograms', link: ''})
      this.showSortByDropDown = !this.showSortByDropDown
    },

    openFilterDropDown () {
      this.loadLogDashboardActivity({action: 'clickExploreProgramFilterBy', page: 'explorePrograms', link: ''})
      $('#programListFilterPopup .popup').attr('tabindex', '0')
      this.showFilterDropDown = !this.showFilterDropDown
    },

    closeFilterDropDown () {
      this.showFilterDropDown = false
    },

    closeSortByDropDown () {
      this.showSortByDropDown = false
    },

    addCommaInNumber (numValue) {
      return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getModalityValue(key){
        let arr = this.programGuideMadalityTypeArray
        for(let i=0;i<arr.length;i++){
            if(arr[i].key===key){
                return arr[i].value
            }
        }
      return key
    },
    getFundingValue(key){
        let arr = this.programGuideFundingTypeArray
        for(let i=0;i<arr.length;i++){
            if(arr[i].key===key){
                return arr[i].value
            }
        }
      return key
    },

    updateTitleHeight (index) {
      let titleContainerHeight = $('#entityName_' + index).height()
      if (titleContainerHeight > 30) {
        $('#entityDesc_' + index).addClass('srt_desc')
      }
    },

    setImageBgColor (imageURL) {
      let getImageURL = imageURL.split('/')
      let getImageName = getImageURL[getImageURL.length - 1].match(/(.*)\.[\w]+$/)[1]
      return getImageName.replace(/\./g, '__')
    },

    showMoreDescLnk (entityDescRowId) {
      let descContainerHeight = $('#entityDesc_' + entityDescRowId + ' .desc_txt').height()
      if (descContainerHeight > 65) {
        return 'show_more_link'
      } else {
        return 'hide_more_link'
      }
    },

    isCustomRangeFilterActive () {
      const medianIncomePerYear = this.facetFieldMap.programGuideIncomeRange
      let selectedRangeFilter = this.filter[medianIncomePerYear]
      return selectedRangeFilter && selectedRangeFilter.isCustom
    },

    isTermFilterSelected (facet, fieldName) {
      let valuesToFilter = this.filter[fieldName]
      let fieldValue = facet.key
      return valuesToFilter && valuesToFilter.includes(fieldValue)
    },

    isRangeFilterSelected (rangeFacet, fieldName) {
      let selectedRangeFilter = this.filter[fieldName].rangeInterval
      return selectedRangeFilter && selectedRangeFilter === rangeFacet.rangeInterval
    },
    isFilterSelected (facet, fieldName) {
      return this.isTermFilterSelected(facet, fieldName) || this.isRangeFilterSelected(facet, fieldName)
    },

    filterSelected (facet, facetName, deleted) {
      const fieldName = this.facetFieldMap[facetName]
      const fieldValue = facet.key || facet.rangeInterval
      const isRangeFacet = fieldName === this.facetFieldMap.programGuideIncomeRange
      const isCostRangeFacet = fieldName === this.facetFieldMap.programGuideCostRange
      if (isRangeFacet) {
        // NOTE only allow one range filter at a time
        this.filter[fieldName] = {
          from: facet.from,
          to: facet.to,
          rangeInterval: facet.rangeInterval,
          isCustom: facet.isCustom === true
        }
        if (!facet.isCustom) {
          this.customIncomeMin = ''
          this.customIncomeMax = ''
          this.$forceUpdate()
        }
        if (!this.selectedFacetNames.includes(facetName)) {
          this.selectedFacetNames.push(facetName)
        }
        this.isIncomeRangeDirty = true
      } else if(isCostRangeFacet){
          this.filter[fieldName] = {
            from: facet.from,
            to: facet.to,
            rangeInterval: facet.rangeInterval
          }
          if (!this.selectedFacetNames.includes(facetName)) {
            this.selectedFacetNames.push(facetName)
          }
          this.$forceUpdate()
          this.isIncomeRangeDirty = true

      } else if (this.isTermFilterSelected(facet, fieldName)) {
        this.filter[fieldName] = this.filter[fieldName].filter(v => v !== fieldValue)

        // remove the facetName from selected list if no other value in that category is selected
        // ex) facetName = 'department', this.filter.department = ['CSCI'] ==> selectedFacetNames = ['department']
        // ex2) facetName = 'department', this.filter.department = [] ==> selectedFacetNames = []
        const isFacetSelected = this.selectedFacetNames.includes(facetName)
        const isFacetUnused = this.filter[fieldName].length === 0
        if (isFacetSelected && isFacetUnused) {
          this.selectedFacetNames = this.selectedFacetNames.filter(v => v !== facetName)
        }
      } else {
        this.filter[fieldName].push(fieldValue)
        if (!this.selectedFacetNames.includes(facetName)) {
          this.selectedFacetNames.push(facetName)
        }
      }
      // if not selected, add the value to the filter and selectedFacetNames list
      this.loadProgramGuideResults()
      if (deleted) {
        this.programCategorySearch = ''
        this.programSubCategorySearch = ''
        this.programCollegeSearch = ''
        this.programLevelSearch = ''
      }
    },

    buildTermClause (fieldName, filterValues) {
      let clause = {
        'terms': {}
      }
      clause.terms[fieldName] = filterValues
      return clause
    },

    buildRangeClause (fieldName, from, to) {
      let clause = {'range': {}}
      clause.range[fieldName] = {}
      if (from) {
        clause.range[fieldName]['gte'] = from
      }
      if (to) {
        clause.range[fieldName]['lt'] = to
      }
      return clause
    },
    showAffiliatedProgramsOnResult () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.showAffiliatedPrograms) {
        return false
      }
      return exploreProgramsFlagMap.showAffiliatedPrograms.enabled
    },

    initializeSearchData () {
      this.searchTerms = this.programGuideSearchTerms || ''
      this.selectedFacetNames = this.programGuideSearchSelectedFacetNames || []
      this.customIncomeMin = this.programGuideSearchCustomIncomeMin || ''
      this.customIncomeMax = this.programGuideSearchCustomIncomeMax || ''
      if (this.programGuideSearchTerms) {
        this.selectedSort = this.relevanceSort
      } else {
        this.selectedSort = this.titleSort // Always default to title sort intitially
      }
      let filter = this.programGuideSearchFilter
      if (this.isFilterEmpty(filter)) {
        Object.values(this.facetFieldMap).forEach(fieldName => {
          if ((fieldName === 'customTags.keyword')) {
            let values = []
            if (this.isCustomTagFilterEnabled) {
              this.customTagOptions.forEach(item => {
                values.push(item.key)
                item.isSelected = true
              })
            }
            filter[fieldName] = values
          } else {
            filter[fieldName] = []
          }
        })
      }
      if (filter.modalityType.length > 0) {
        filter.modalityType.forEach((item, i) => {
          this.programGuideMadalityTypeArray.forEach((mod, j) => {
            if (item === mod.key) {
              this.modalityType.push(mod)
            }
          })
        })
      }
      if (filter.fundingType.length > 0) {
        filter.fundingType.forEach((item, i) => {
          this.programGuideFundingTypeArray.forEach((funding, j) => {
            if (item === funding.key) {
              this.fundingType.push(funding)
            }
          })
        })
      }
      this.filter = filter
    },

    isFilterEmpty (filter) {
      let isEmpty = true
      filter = filter || this.filter
      Object.values(filter).forEach(filterValues => {
        isEmpty = isEmpty && !filterValues
      })
      return isEmpty
    },

    filterByBlankUserExternalId () {
      let filter = {
        'bool': {
          'must': [],
          'must_not': {
            'exists': {
              'field': 'userExternalId'
            }
          }
        }
      }
      return filter
    },

    buildFilter () {
      let elasticSearchFilter = this.filterByBlankUserExternalId()
      let filter = this.filter
      let buildTermClause = this.buildTermClause
      let buildRangeClause = this.buildRangeClause
      let medianIncomePerYear = this.facetFieldMap.programGuideIncomeRange
      let cost = this.facetFieldMap.programGuideCostRange
      Object.keys(filter).forEach(fieldName => {
        const isTermFacet = (fieldName !== medianIncomePerYear && fieldName !== cost)
        const isRangeFacet = !isTermFacet
        let filterValues = filter[fieldName]
        if (isTermFacet && filterValues && filterValues.length > 0) {
          elasticSearchFilter.bool.must.push(buildTermClause(fieldName, filterValues))
        } else if (isRangeFacet && filterValues.rangeInterval) {
          elasticSearchFilter.bool.must.push(buildRangeClause(fieldName, filterValues.from, filterValues.to))
        }
      })
      return elasticSearchFilter
    },

    getFacetFilter (facetName) {
      let facetFilter = {
        'bool': {
          'must': []
        }
      }
      const isFilterEmpty = this.isFilterEmpty()
      if (!isFilterEmpty && !this.selectedFacetNames.includes(facetName)) {
        let buildFilter = this.buildFilter()
        facetFilter.bool.must = facetFilter.bool.must.concat(buildFilter.bool.must)
        if (Object.keys(buildFilter.bool.must_not).length > 0) {
          facetFilter.bool['must_not'] = buildFilter.bool.must_not
        }
      }
      return facetFilter
    },
    truncate (input) {
      if (input && input.length > 125) {
        return input.substring(0, 125) + '...'
      }
      return input
    },

    setListHeight () {
      let windowHeight = $(window).height()
      let filterSectionHeight = $('.page_subheading').innerHeight()
      $('.page_content_container').height(windowHeight - (131 + filterSectionHeight))
    },

    handleWindowResize (event) {
      this.setListHeight()
    },

    beforeDestroy: function () {
      window.removeEventListener('resize', this.handleWindowResize)
    },

    buildFacet (field, order, facetName) {
      return {
        'aggs': {
          'termObj': {
            'terms': {
              'field': field,
              'order': order,
              'size': 1000
            }
          }
        },
        'filter': this.getFacetFilter(facetName)
      }
    },

    closeAllDropDowns () {
      this.closeAreaOfStudyDropDown()
      this.closeSubCategoryDropDown()
      this.closeCollegeDropDown()
      this.closeprogramLevelDropDown()
      this.closeIncomeRangeDropDown()
      this.closeSortByDropDown()
    },

    customRangeSelected () {
      // ignore ranges where either inputs are empty to avoid confusing UX.
      this.validateCustomRanges()
      if (!this.customIncomeMin && !this.customIncomeMax) {
        return this.isCustomRangeFilterActive() ? this.clearRangeFilter() : this.closeIncomeRangeDropDown()
      }
      let range = {from: this.customIncomeMin, to: this.customIncomeMax}
      range.rangeInterval = range.from + '-' + range.to
      if (!range.from) {
        range.rangeInterval = '< ' + range.to
      } else if (!range.to) {
        range.rangeInterval = '> ' + range.from
      }
      range.isCustom = true
      this.closeIncomeRangeDropDown()
      this.filterSelected(range, 'programGuideIncomeRange')
    },

    clearRangeFilter () {
      const programGuideIncomeRange = 'programGuideIncomeRange'
      const medianIncomePerYear = this.facetFieldMap[programGuideIncomeRange]
      this.customIncomeMin = ''
      this.customIncomeMax = ''
      this.isIncomeRangeDirty = false
      this.filter[medianIncomePerYear] = {}
      this.selectedFacetNames = this.selectedFacetNames.filter(v => v !== programGuideIncomeRange)
      this.closeIncomeRangeDropDown()
      this.loadProgramGuideResults()
    },

   clearCostRangeFilter () {
      const cost = this.facetFieldMap['programGuideCostRange']
      this.filter[cost] = {}
      this.selectedFacetNames = this.selectedFacetNames.filter(v => v !== cost)
      this.loadProgramGuideResults()
    },


    notifySuccess (text) {
      return this.$notify({
        group: 'notify',
        type: 'success',
        title: '',
        text: text
      })
    },

    notifyFailure (text) {
      return this.$notify({
        group: 'notify',
        type: 'error',
        title: '',
        text: text
      })
    },

    async bookmarkProgramGuide (programGuide) {
      const bookmark = {
        'source': 'explore',
        'entityType': 'programguide',
        'entityTitle': programGuide.title,
        'entityUuid': programGuide.uuid,
        'institutionId': programGuide.institutionId,
        'userId': this.userId
      }
      const response = await this.loadCreateBookmarks(bookmark)
      const message = (response ? 'Successfully bookmarked \'' : 'Unable to bookmark \'') + programGuide.title + '\''
      const notify = response ? this.notifySuccess : this.notifyFailure
      notify(message)
      await this.loadAllBookmarks() // Refresh Vuex state to mark ProgramGuide as bookmarked
    },

    async deleteProgramGuideBookmark (programGuide) {
      await this.loadDeleteBookmark(programGuide.bookmark.uuid)
      this.notifySuccess('Successfully deleted bookmark \'' + programGuide.title + '\'')
      await this.loadAllBookmarks() // Refresh Vuex state to mark ProgramGuide as bookmarked
    },

    isBookmarked (programGuide) {
      return programGuide.bookmark && programGuide.bookmark.uuid
    },

    validateCustomRanges () {
      let customIncomeMin = this.customIncomeMin
      let customIncomeMax = this.customIncomeMax
      if (isNaN(customIncomeMin) || isNaN(customIncomeMax) || customIncomeMin < 0 || customIncomeMax < 0) {
        customIncomeMin = ''
        customIncomeMax = ''
      }
      this.customIncomeMin = customIncomeMin
      this.customIncomeMax = customIncomeMax
      this.$forceUpdate()
    },

    getExploreSearchPackage () {
      let packages = this.packages
      if (!packages || !packages.length || packages.length <= 0) {
        return {}
      }
      return PackageUtil.getExploreSearchPackage(packages)
    },

    buildFacets () {
      const termOrder = {'_key': 'asc'}
      let buildFacet = this.buildFacet
      let getFacetFilter = this.getFacetFilter
      let facets = {
        'programGuideCategory': buildFacet('category.raw', termOrder, 'programGuideCategory'),
        'programGuideSubCategory': buildFacet('subCategory.raw', termOrder, 'programGuideSubCategory'),
        'programGuideCollege': buildFacet('colleges.raw', termOrder, 'programGuideCollege'),
        'programGuideLevel': buildFacet('programLevel.keyword', termOrder, 'programGuideLevel'),
        'programGuideCustomTag': buildFacet('customTags.keyword', termOrder, 'programGuideCustomTag'),
        'programGuideIncomeRange': {
          'aggs': {
            'rangeObj': {
              'range': {
                'field': 'medianIncomePerYear',
                'ranges': [
                  {'to': 25000},
                  {'from': 25000, 'to': 50000},
                  {'from': 50000, 'to': 75000},
                  {'from': 75000}
                ]
              }
            }
          },
          'filter': getFacetFilter('programGuideIncomeRange')
        },
       'programGuideCostRange': {
          'aggs': {
            'rangeObj': {
              'range': {
                'field': 'cost',
                'ranges': [
                  {'to': 5000},
                  {'from': 5000, 'to': 10000},
                  {'from': 10000, 'to': 20000},
                  {'from': 20000}
                ]
              }
            }
          },
          'filter': getFacetFilter('programGuideCostRange')
        }

      }
      return facets
    },

    calculateCreditProgressClicked (programGuide) {
      this.selectedProgramGuide = programGuide
      this.creditProgressTargetId = 'creditProgressPopup_' + programGuide.uuid
      this.showCreditProgressPopup = true
    },

    addCompletedCourses () {
      return this.$router.push({name: 'selfReportedCourseList'})
    }
  },

  computed: {
    ...mapState({
      'permission': state => state.user.permission,
      'enabledFeatures': state => state.institution.enabledFeatures,
      'packages': state => state.institution.packages,
      'programGuideFacetResults': state => state.explore.programGuideFacetResults,
      'programGuideSearchResults': state => state.explore.programGuideSearchResults,
      'bookmarks': state => state.explore.bookmarks,
      'programGuideSearchTerms': state => state.explore.programGuideSearchTerms,
      'programGuideSearchSort': state => state.explore.programGuideSearchSort,
      'programGuideSearchFilter': state => state.explore.programGuideSearchFilter,
      'programGuideSearchSelectedFacetNames': state => state.explore.programGuideSearchSelectedFacetNames,
      'programGuideSearchCustomIncomeMin': state => state.explore.programGuideSearchCustomIncomeMin,
      'programGuideSearchCustomIncomeMax': state => state.explore.programGuideSearchCustomIncomeMax,
      'planningStream': state => state.dashboard.planningStream,
      'total': state => state.explore.programTotal,
      'programScrollTop': state => state.explore.programScrollTop,
      'programScrollLeft': state => state.explore.programScrollLeft
    }),
    isBGTFeatureEnabled () {
      let bgtFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_SEARCH_BGT_SOURCE]
      return bgtFeature && bgtFeature.enabled
    },
    careerDataSource () {
      if (this.isBGTFeatureEnabled) {
        return 'Source: Burning Glass. 2018-2028'
      }
      return 'Source: BLS. 2016-2026'
    },
    parentComponent () {
      return this
    },
    isCustomTagFilterEnabled () {
      let customTagsFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAM_CUSTOM_TAGS_FEATURE_ID]
      if (customTagsFeature) {
        return customTagsFeature.enabled
      }
      return false
    },
    customTagOptions () {
      let customTagOptions = []
      let customTagsFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAM_CUSTOM_TAGS_FEATURE_ID]
      if (customTagsFeature) {
        let flags = customTagsFeature.flags
        for (let i = 0; i < flags.length; i++) {
          let flag = flags[i]
          if (flag.enabled) {
            let text = (flag.label && flag.label.length > 0) ? flag.label : flag.title
            customTagOptions.push({key: text, label: text + ' Pathways'})
          }
        }
      }
      return customTagOptions
    },
    exploreProgramsFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.EXPLORE_PROGRAMS
      let exploreSearchPackage = this.getExploreSearchPackage()
      return PackageUtil.getFlagsFromPackageFeature(exploreSearchPackage, featureId)
    },

    showDescriptionOnResult () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultDescription) {
        return false
      }
      return exploreProgramsFlagMap.searchResultDescription.enabled
    },
    showMedianIncomeOnResult () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultMedianIncome) {
        return false
      }
      return exploreProgramsFlagMap.searchResultMedianIncome.enabled
    },
    medianIncomeResultLabel () {
      const defaultLabel = 'median income'
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultMedianIncome) {
        return defaultLabel
      }
      return exploreProgramsFlagMap.searchResultMedianIncome.label || defaultLabel
    },
    showJobPostingsOnResult () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultJobPosting) {
        return false
      }
      return exploreProgramsFlagMap.searchResultJobPosting.enabled
    },
    jobPostingsResultLabel () {
      const defaultLabel = 'job postings'
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultJobPosting) {
        return defaultLabel
      }
      return exploreProgramsFlagMap.searchResultJobPosting.label || defaultLabel
    },
    showGrowthRateOnResult () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultGrowthRate) {
        return false
      }
      return exploreProgramsFlagMap.searchResultGrowthRate.enabled
    },
    growthRateResultLabel () {
      const defaultLabel = 'growth'
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultGrowthRate) {
        return defaultLabel
      }
      return exploreProgramsFlagMap.searchResultGrowthRate.label || defaultLabel
    },
    showBookmarkOnResult () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultBookMark) {
        return false
      }
      return exploreProgramsFlagMap.searchResultBookMark.enabled
    },
    showProgramTypeTagOnResult () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultProgramTypeTag) {
        return false
      }
      return exploreProgramsFlagMap.searchResultProgramTypeTag.enabled
    },
    isSortByEnabled () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.sortBy) {
        return false
      }
      return exploreProgramsFlagMap.sortBy.enabled
    },
    isSortByRelevanceEnabled () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.sortByRelevance) {
        return false
      }
      return exploreProgramsFlagMap.sortByRelevance.enabled
    },
    sortByRelevanceLabel () {
      const defaultLabel = 'Relevance'
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.sortByRelevance) {
        return defaultLabel
      }
      return exploreProgramsFlagMap.sortByRelevance.label || defaultLabel
    },
    isSortByTitleEnabled () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.sortByTitle) {
        return false
      }
      return exploreProgramsFlagMap.sortByTitle.enabled
    },
    sortByTitleLabel () {
      const defaultLabel = 'Title'
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.sortByTitle) {
        return defaultLabel
      }
      return exploreProgramsFlagMap.sortByTitle.label || defaultLabel
    },
    isSortByMedianIncomeEnabled () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.sortByMedianIncome) {
        return false
      }
      return exploreProgramsFlagMap.sortByMedianIncome.enabled
    },
    sortByMedianIncomeLabel () {
      const defaultLabel = 'Median Income'
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.sortByMedianIncome) {
        return defaultLabel
      }
      return exploreProgramsFlagMap.sortByMedianIncome.label || defaultLabel
    },
    isSortByJobPostingEnabled () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.sortByJobPosting) {
        return false
      }
      return exploreProgramsFlagMap.sortByJobPosting.enabled
    },
    sortByJobPostingsLabel () {
      const defaultLabel = 'Job Postings'
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.sortByJobPosting) {
        return defaultLabel
      }
      return exploreProgramsFlagMap.sortByJobPosting.label || defaultLabel
    },
    isSortByGrowthRateEnabled () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.sortByGrowthRate) {
        return false
      }
      return exploreProgramsFlagMap.sortByGrowthRate.enabled
    },
    sortByGrowthRateLabel () {
      const defaultLabel = 'Growth'
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.sortByGrowthRate) {
        return defaultLabel
      }
      return exploreProgramsFlagMap.sortByGrowthRate.label || defaultLabel
    },
    sortByOptions () {
      let options = []
      let sorts = this.sorts
      if (this.isSortByRelevanceEnabled) {
        sorts[0].name = this.sortByRelevanceLabel
        options.push(sorts[0])
      }
      if (this.isSortByTitleEnabled) {
        sorts[1].name = this.sortByTitleLabel
        options.push(sorts[1])
      }
      if (this.isSortByMedianIncomeEnabled) {
        sorts[2].name = this.sortByMedianIncomeLabel
        options.push(sorts[2])
      }
      if (this.isSortByJobPostingEnabled) {
        sorts[3].name = this.sortByJobPostingsLabel
        options.push(sorts[3])
      }
      if (this.isSortByGrowthRateEnabled) {
        sorts[4].name = this.sortByGrowthRateLabel
        options.push(sorts[4])
      }
      return options
    },
    isSearchBarEnabled () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchPrograms) {
        return false
      }
      return exploreProgramsFlagMap.searchPrograms.enabled
    },
    isAreaOfStudyEnabled () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.selectAreaOfStudy) {
        return false
      }
      return exploreProgramsFlagMap.selectAreaOfStudy.enabled
    },
    areaOfStudyLabel () {
      const defaultLabel = 'Area of Study'
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.selectAreaOfStudy) {
        return defaultLabel
      }
      return exploreProgramsFlagMap.selectAreaOfStudy.label || defaultLabel
    },
    isSubCategoryEnabled () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.selectSubCategory) {
        return false
      }
      return exploreProgramsFlagMap.selectSubCategory.enabled
    },
    subCategoryLabel () {
      const defaultLabel = 'Sub Category'
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.selectSubCategory) {
        return defaultLabel
      }
      return exploreProgramsFlagMap.selectSubCategory.label || defaultLabel
    },
    isCollegeEnabled () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.selectCollege) {
        return false
      }
      return exploreProgramsFlagMap.selectCollege.enabled
    },
    collegeLabel () {
      const defaultLabel = 'College'
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.selectCollege) {
        return defaultLabel
      }
      return exploreProgramsFlagMap.selectCollege.label || defaultLabel
    },
    isProgramLevelEnabled () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.selectProgramLevel) {
        return false
      }
      return exploreProgramsFlagMap.selectProgramLevel.enabled
    },
    programLevelLabel () {
      const defaultLabel = 'Program Level'
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.selectProgramLevel) {
        return defaultLabel
      }
      return exploreProgramsFlagMap.selectProgramLevel.label || defaultLabel
    },
        isModalityEnabled () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.modalityFilter) {
        return false
      }
      return exploreProgramsFlagMap.modalityFilter.enabled
    },
    modalityLabel () {
      const defaultLabel = 'Modality'
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.modalityFilter) {
        return defaultLabel
      }
      return exploreProgramsFlagMap.modalityFilter.label || defaultLabel
    },

    isCostRangeEnabled () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.costRangeFilter) {
        return false
      }
      return exploreProgramsFlagMap.costRangeFilter.enabled
    },
    costRangeLabel () {
      const defaultLabel = 'Cost'
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.costRangeFilter) {
        return defaultLabel
      }
      return exploreProgramsFlagMap.costRangeFilter.label || defaultLabel
    },
    isFundingFilterEnabled () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.fundingFilter) {
        return false
      }
      return exploreProgramsFlagMap.fundingFilter.enabled
    },
    fundingLabel () {
      const defaultLabel = 'Funding Available'
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.fundingFilter) {
        return defaultLabel
      }
      return exploreProgramsFlagMap.fundingFilter.label || defaultLabel
    },

    isIncomeRangeEnabled () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.selectIncomeRange) {
        return false
      }
      return exploreProgramsFlagMap.selectIncomeRange.enabled
    },
    incomeRangeLabel () {
      const defaultLabel = 'Income Range'
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.selectIncomeRange) {
        return defaultLabel
      }
      return exploreProgramsFlagMap.selectIncomeRange.label || defaultLabel
    },
    formattedIndexList () {
      let allIndices = this.allIndexes
      return this.joinListWithCommas(allIndices)
    },
    formattedLibraryList () {
      let allFolders = this.allFolders
      return this.joinListWithCommas(allFolders)
    },
    programGuideCategories () {
      let categories = this.formattedFacetResults.programGuideCategory
      if (categories && categories.length > 0) {
        return categories.filter(item => {
          return item.key.toLowerCase().indexOf(this.programCategorySearch.toLowerCase()) > -1
        })
      }
      return categories
    },
    programGuideSubCategories () {
      let subCategories = this.formattedFacetResults.programGuideSubCategory
      if (subCategories && subCategories.length > 0) {
        return subCategories.filter(item => {
          return item.key.toLowerCase().indexOf(this.programSubCategorySearch.toLowerCase()) > -1
        })
      }
      return subCategories
    },
    programGuideColleges () {
      let colleges = this.formattedFacetResults.programGuideCollege
      if (colleges && colleges.length > 0) {
        return colleges.filter(item => {
          return item.key.toLowerCase().indexOf(this.programCollegeSearch.toLowerCase()) > -1
        })
      }
      return colleges
    },
    programGuideLevels () {
      let levels = this.formattedFacetResults.programGuideLevel
      if (levels && levels.length > 0) {
        return levels.filter(item => {
          return item.key.toLowerCase().indexOf(this.programLevelSearch.toLowerCase()) > -1
        })
      }
      return levels
    },
    programGuideCustomTags () {
      return this.formattedFacetResults.programGuideCustomTag
    },
    programGuideMadalityTypeArray () {
      return [{key:"online", value:"Online"}, {key:"inperson", value:"In person"}, {key:"hybrid", value:"Hybrid"}]
    },
    programGuideFundingTypeArray () {
      return [{key:"free", value:"Free"}, {key:"full", value:"Fully funded"}, {key:"partial", value:"Financial Aid"}]
    },
    formattedFacetResults () {
      let formattedFacetResults = {}
      let facetResults = this.programGuideFacetResults
      let facetFieldMap = this.facetFieldMap
      let isTermFilterSelected = this.isTermFilterSelected
      let isRangeFilterSelected = this.isRangeFilterSelected
      let currencyLabel = this.currencyLabel
      let addCommaInNumber = this.addCommaInNumber
      this.allFacetNames.forEach((facetName) => {
        const fieldName = facetFieldMap[facetName]
        let facetResult = (facetResults && facetResults[facetName]) ? _.cloneDeep(facetResults[facetName]) : {}
        if (facetResult && Object.keys(facetResult).length > 0) {
          let isRangeFacet = Object.keys(facetResult).includes('rangeObj')
          if (isRangeFacet) {
            facetResult = _.cloneDeep(facetResult.rangeObj.buckets)
            facetResult.forEach((range) => {
              if (!range.from) {
                let formatted = addCommaInNumber(range.to)
                range.rangeInterval = '< ' + formatted
                range.label = '< ' + currencyLabel + formatted
              } else if (!range.to) {
                let formatted = addCommaInNumber(range.from)
                range.rangeInterval = '> ' + formatted
                range.label = '>= ' + currencyLabel + formatted
              } else if (range.to && range.from) {
                range.rangeInterval = range.from + '-' + range.to
                range.label = (currencyLabel + addCommaInNumber(range.from)) + '-' + (currencyLabel + addCommaInNumber(range.to))
              }
              range.isSelected = isRangeFilterSelected(range, fieldName)
            })
          } else {
            facetResult = facetResult.termObj.buckets
            facetResult.forEach((termFacet) => {
              termFacet.isSelected = isTermFilterSelected(termFacet, fieldName)
            })
          }
        }
        formattedFacetResults[facetName] = facetResult
      })
      return formattedFacetResults
    },
    formattedResults () {
      let formatted = []
      let results = this.programGuideSearchResults
      if (!results || results.length <= 0) {
        return formatted
      }
      let getBookmark = this.getProgramGuideBookmark
      results.forEach(function (programGuide) {
        let elasticSearchDocument = programGuide.elasticSearchDocument
        programGuide.cipCode = elasticSearchDocument.cipCode
        programGuide.code = elasticSearchDocument.code
        programGuide.institutionId = elasticSearchDocument.institutionId
        programGuide.medianIncomePerYear = elasticSearchDocument.medianIncomePerYear
        programGuide.growthRate = elasticSearchDocument.growthRate
        programGuide.totalJobPostings = elasticSearchDocument.totalJobPostings
        programGuide.thumbnailURL = elasticSearchDocument.thumbnailURL
        programGuide.bookmark = getBookmark(programGuide)
        programGuide.lowestPrice = elasticSearchDocument.lowestPrice
        programGuide.lowestPriceCurrency = elasticSearchDocument.lowestPriceCurrency
        programGuide.cost = elasticSearchDocument.cost
        programGuide.modalityType = elasticSearchDocument.modalityType
        programGuide.fundingType = elasticSearchDocument.fundingType
        programGuide.freeProgram= elasticSearchDocument.freeProgram
        programGuide.pragyaProgram= elasticSearchDocument.pragyaProgram
        programGuide.disableLMI = elasticSearchDocument.disableLMI
        programGuide.paymentProcessedOutOfPragya = elasticSearchDocument.paymentProcessedOutOfPragya

        formatted.push(programGuide)
      })
      return formatted
    },
    allFacetNames () {
      return Object.keys(this.facetFieldMap)
    },
    fieldsToFilter () {
      return Object.values(this.facetFieldMap)
    },
    currencyLabel () {
      return '$'
    },
    relevanceSort () {
      return this.sorts[0].clause
    },
    titleSort () {
      return this.sorts[1].clause
    },
    isFacetResultsEmpty () {
      let isEmpty = true
      let formattedFacetResults = this.formattedFacetResults
      this.allFacetNames.forEach(facetName => {
        let facetResult = formattedFacetResults[facetName]
        if (facetName === 'programGuideIncomeRange' && facetResult.length > 0) {
          facetResult.forEach((range) => {
            isEmpty = isEmpty && range.doc_count === 0
          })
        } else {
          isEmpty = isEmpty && (!facetResult || facetResult.length === 0)
        }
      })
      return isEmpty
    },
    exploreSearchFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.EXPLORE_SEARCH_FEATURE_ID
      let exploreSearchPackage = this.getExploreSearchPackage()
      return PackageUtil.getFlagsFromPackageFeature(exploreSearchPackage, featureId)
    },
    isStickyFacetsEnabled () {
      let exploreSearchFlagMap = this.exploreSearchFlagMap
      if (!exploreSearchFlagMap || !exploreSearchFlagMap.enableStickyFacets) {
        return false
      }
      return this.exploreSearchFlagMap.enableStickyFacets.enabled
    },
    showFacetCounts () {
      let exploreSearchFlagMap = this.exploreSearchFlagMap
      if (!exploreSearchFlagMap || !exploreSearchFlagMap.showFacetCounts) {
        return false
      }
      return this.exploreSearchFlagMap.showFacetCounts.enabled
    },
    showCalculateRequiredCreditOnResult () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultCalculateRequiredCredit) {
        return false
      }
      return exploreProgramsFlagMap.searchResultCalculateRequiredCredit.enabled
    },
    isShowCourseProgressEnabled () {
      let progressViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROGRESS_VIEW_FEATURE_ID]
      if (progressViewFeature && progressViewFeature.enabled) {
        let flags = progressViewFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showCourseProgress' || flags[i].title === 'showCourseProgressOnOverall') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    showAddCompletedCoursesOnResult () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultAddCompletedCourses) {
        return false
      }
      return exploreProgramsFlagMap.searchResultAddCompletedCourses.enabled
    },
    showTransferredCoursesCreditProgress () {
      let transferCoursesFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.TRANSFER_PREVIOUS_COURSES_FEATURE_ID]
      if (transferCoursesFeature && transferCoursesFeature.enabled) {
        let flags = transferCoursesFeature.flags
        for (let i = 0; i < flags.length; i++) {
          let flag = flags[i]
          if (flag.title === 'showTransferredCoursesCreditProgress') {
            return flag.enabled
          }
        }
      }
      return false
    },
    isStudentLogin () {
      return (localStorage.getItem('userrole') === 'Student')
    },
    exploreProgramsLabel () {
      let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAMS]
      if (exploreFeature) {
        for (var i = 0; i < exploreFeature.flags.length; i++) {
          if (exploreFeature.flags[i].title === 'useProgramLongText') {
            if (exploreFeature.flags[i].isEnabled) {
              return exploreFeature.flags[i].label
            }
          }
        }
      }
      return 'program'
    },
    exploreProgramsLabelPlural () {
      let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAMS]
      if (exploreFeature) {
        for (var i = 0; i < exploreFeature.flags.length; i++) {
          if (exploreFeature.flags[i].title === 'useProgramLongText') {
            if (exploreFeature.flags[i].isEnabled) {
              return exploreFeature.flags[i].label + 's'
            }
          }
        }
      }
      return 'programs'
    }
  },
  watch: {
    showAreaOfStudyDropDown (newValue, oldValue) {
      if (newValue) {
        this.closeprogramLevelDropDown()
        this.closeSubCategoryDropDown()
        if (!this.isIncomeRangeDirty) {
          this.closeIncomeRangeDropDown()
        }
        this.closeSortByDropDown()
      } else {
        this.closeAreaOfStudyDropDown()
      }
    },
    showSubCategoryDropDown (newValue, oldValue) {
      if (newValue) {
        this.closeprogramLevelDropDown()
        this.closeAreaOfStudyDropDown()
        this.closeCollegeDropDown()
        if (!this.isIncomeRangeDirty) {
          this.closeIncomeRangeDropDown()
        }
        this.closeSortByDropDown()
      } else {
        this.closeSubCategoryDropDown()
      }
    },
    showCollegeDropDown (newValue, oldValue) {
      if (newValue) {
        this.closeSubCategoryDropDown()
        this.closeprogramLevelDropDown()
        this.closeAreaOfStudyDropDown()
        if (!this.isIncomeRangeDirty) {
          this.closeIncomeRangeDropDown()
        }
        this.closeSortByDropDown()
      } else {
        this.closeCollegeDropDown()
      }
    },
    showprogramLevelDropDown (newValue, oldValue) {
      if (newValue) {
        this.closeAreaOfStudyDropDown()
        this.closeSubCategoryDropDown()
        this.closeCollegeDropDown()
        if (!this.isIncomeRangeDirty) {
          this.closeIncomeRangeDropDown()
        }
        this.closeSortByDropDown()
      } else {
        this.closeprogramLevelDropDown()
      }
    },
    showIncomeRangeDropDown (newValue, oldValue) {
      if (newValue) {
        this.closeprogramLevelDropDown()
        this.closeAreaOfStudyDropDown()
        this.closeSubCategoryDropDown()
        this.closeCollegeDropDown()
        this.closeSortByDropDown()
      } else {
        this.closeIncomeRangeDropDown()
      }
    },
    showSortByDropDown (newValue, oldValue) {
      if (newValue) {
        this.closeprogramLevelDropDown()
        this.closeAreaOfStudyDropDown()
        this.closeSubCategoryDropDown()
        this.closeCollegeDropDown()
        this.closeFilterDropDown()
        if (!this.isIncomeRangeDirty) {
          this.closeIncomeRangeDropDown()
        }
      } else {
        this.closeSortByDropDown()
      }
    },
    showFilterDropDown (newValue, oldValue) {
      if (newValue) {
        this.closeprogramLevelDropDown()
        this.closeAreaOfStudyDropDown()
        this.closeSubCategoryDropDown()
        this.closeCollegeDropDown()
        this.closeSortByDropDown()
        if (!this.isIncomeRangeDirty) {
          this.closeIncomeRangeDropDown()
        }
      } else {
        this.closeFilterDropDown()
      }
    },
    selectedSort (newSort, oldSort) {
      if ((newSort.length > 0) && (oldSort.length > 0)) {
        this.loadProgramGuideResults()
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/explore/components/ExploreProgramGuideResults.vue